import { OreStack } from "@edenredespana/oreneta"
import { useHelpCenter } from "@/HelpCenter/ui/context"
import {
    NewTicketHeader,
    NewTicketFooter,
    NewTicketStep1,
    NewTicketStep2,
    NewTicketStep3,
    NewTicketStep4,
    NewTicketCancelModal
} from '@/HelpCenter/ui/molecules'

export const NewTicketFormContainer = () => {
    const { step, setIsModalOpen, isModalOpen } = useHelpCenter()
    const getStep = () => {
        switch (step) {
            case 1:
                return <NewTicketStep1 />
            case 2:
                return <NewTicketStep2 />
            case 3:
                return <NewTicketStep3 />
            case 4:
                return <NewTicketStep4 />
            default:
                return <NewTicketStep1 />
        }
    }


    return (
        <>
        <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
            <OreStack space="medium" placeContent="stretch">
                <NewTicketHeader step={step} setIsModalOpen={setIsModalOpen} />
                {getStep()}
                <NewTicketFooter />
            </OreStack>
        </div>
        <NewTicketCancelModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
        </>
    )
}